module.exports = __webpack_public_path__ + "static/media/presentation_2.1d0b7ff4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transplant/icons/presentation_2.svg
// module id = 647
// module chunks = 1